import "./authverification.css";
import {
  React,
  useNavigate,
  useLocation,
  OtpInput,
  useEffect,
  Button,
  DigitalSignage,
  toast,
  useState,
  LoadingSpinner,
  capturepageanalytics,
  captureeventbaseanalytics,
  BASEURL,
} from "../../../Libraries/Authentication/AuthVerification/index";

import BoostBoardLogo from '../../../Assets/svgs/boostboard_logo.svg'

const AuthVerification = () => {
  const navigate = useNavigate(null);
  const location = useLocation(null);
  const [otp, setotp] = useState("");
  const [loading, setloading] = useState(false);
  const [isResendagain, setisResendagain] = useState(false);

  const handleotpverification = (e) => {
    e.preventDefault();

    try {
      if (otp.length < 6) // OTP length changed from 8 to 6 in API Shifting (03-07-2025)
       {
        captureeventbaseanalytics(
          "Customer Creation",
          "OTP VERIFICATION",
          "Please enter the four digit otp"
        );
        toast.error("Please enter the six digit otp");
      } else if (otp.length === 6) // OTP length changed from 8 to 6 in API Shifting (03-07-2025)
         {
        setloading(true);
        const getotpdata = new FormData();
        getotpdata.append("txt_customer_id", location.state.userid);
        getotpdata.append("txt_customer_pin", otp);
        getotpdata.append(
          "txt_customer_password",
          btoa(location.state.password)
        );
        getotpdata.append("txt_customer_email", location.state.email);
        getotpdata.append("txt_customer_phone_number", location.state.phone); //added by maheen for api shifting
        getotpdata.append("function", "VERIFY_OTP_AND_SIGNUP_MANUAL");

        const otprequestoption = {
          method: "POST",
          body: getotpdata,
          cache: "no-cache",
          referrerPolicy: "no-referrer",
        };

        fetch(BASEURL + "customer/signage.php", otprequestoption)
          .then(function (response) {
            if (response.status !== 200) {
              setloading(false);
              toast.error(response.Error);
              console.log("Error", response);
            } else {
              response.json().then(function (data) {
                if (
                  data.connection === "true" &&
                  data.status === "true" &&
                  data.message ===
                    "Customer created successfully."
                ) {
                  setloading(false);
                  toast.success(data.message);
                  captureeventbaseanalytics(
                    "Customer Creation",
                    "customer/verifyOtp.php RESPONSE",
                    data.message
                  );
                  setTimeout(() => {
                    navigate("/login");
                  }, 3000);
                } else if (
                  data.message ===
                  "Invalid PIN Provided multiple times So your Current OTP is Expired. Please Generate OTP Again."
                ) {
                  setisResendagain(true);
                  toast.info(data.message);
                  setloading(false);
                  captureeventbaseanalytics(
                    "Customer Creation",
                    "customer/verifyOtp.php RESPONSE",
                    data.message
                  );
                } else {
                  toast.error(data.message);
                  setloading(false);
                  captureeventbaseanalytics(
                    "Customer Creation",
                    "customer/verifyOtp.php RESPONSE",
                    data.message
                  );
                }
              });
            }
          })
          .catch((error) => {
            setloading(false);
            toast.error(error.error);
            captureeventbaseanalytics(
              "Customer Creation",
              "CustomerSignup_VASServices/csa_ajax.php RESPONSE",
              error.error
            );
          });
      } else {
        toast.error("Please use the right OTP");
      }
    } catch (error) {
      console.log(error);
      setloading(false);
    }
  };

  useEffect(() => {
    capturepageanalytics(window.location.pathname);
    if (
      location.state === null ||
      location.state === undefined ||
      location.state === "null" ||
      location.state === "undefined"
    ) {
      navigate("/signup", { state: null });
    }
  }, [navigate, location]);

  useEffect(() => {
    window.onpopstate = () => {
      navigate("/signup", { state: null });
    };
  }, [navigate]);

  const handleResendotp = () => {
    try {
      setloading(true);
      const getotpdata = new FormData();
      getotpdata.append("txt_customer_id", location.state?.userid);
      getotpdata.append("txt_customer_email", location.state?.email);
      getotpdata.append("function", "GET_OTP");

      const otprequestoption = {
        method: "POST",
        body: getotpdata,
        cache: "no-cache",
        referrerPolicy: "no-referrer",
      };

      fetch(BASEURL + "customer/signage.php", otprequestoption)
        .then(function (response) {
          if (response.status !== 200) {
            setloading(false);
            toast.error(response.status);
            console.log("Error", response);
          } else {
            response.json().then(function (data) {
              if (
                data.connection === "true" &&
                data.status === "true" &&
                data.message === "OTP has been sent via SMS and mail"
              ) {
                setloading(false);
                toast.info(
                  "OTP successfully resent to your registered email address."
                );
              } else {
                setloading(false);
                toast.error(data.message);
              }
            });
          }
        })
        .catch((error) => {
          console.error(error.message);
        });
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <>
      {loading ? <LoadingSpinner /> : null}
      <div
        className="bg_ap"
        style={{
          backgroundImage: `url(${"https://bbapi.nayatel.com/api/api/web/AuthBackgroundImage/authbg.png"}), url(${require("../../../Assets/Images/authbg.png")})`,
        }}
      >
        <div className="card_wrapper_ap">
          <div className="shadow rowdesign_av">
            <div className="auth_logo_av">
              <img src={BoostBoardLogo} alt="logo" width="170px" />
            </div>
            <form className="forgetpassword" onSubmit={handleotpverification}>
              <div className="otp__wrapper">
                <OtpInput
                  value={otp}
                  onChange={(e) => setotp(e)}
                  numInputs={6} // OTP length changed from 8 to 6 in API Shifting (03-07-2025)
                  separator={<span style={{ width: "8px" }}></span>}
                  renderInput={(props) => <input {...props} />}
                  shouldAutoFocus={true}
                  placeholder="********"
                  inputStyle={{
                    border: "1px solid transparent",
                    borderRadius: "8px",
                    width: "100%",
                    height: "45px",
                    fontSize: "12px",
                    color: "#000",
                    fontWeight: "400",
                    caretColor: "blue",
                    backgroundColor: "#eef2f3",
                  }}
                  focusStyle={{
                    border: "1px solid #CFD3DB",
                    outline: "none",
                  }}
                />
              </div>

              <Button
                sx={{
                  width: "100%",
                  mt: "12px",
                }}
                variant="contained"
                type="submit"
                className="capitalized fs-14 fw-bold"
              >
                Submit
              </Button>
            </form>
            {isResendagain ? (
              <div className="otp_verification">
                <span className="resend_otp" onClick={handleResendotp}>
                  Resend OTP
                </span>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthVerification;
